<template lang="pug">
label.input-text
  .input-text__label User name
  input.input-text__input(
    type="text"
    placeholder=""
    v-model.trim="value"
    @keyup="changeFieldValue()"
  )
</template>

<script>
import { mapMutations, mapGetters } from 'vuex'

export default {
  name: 'FieldUserName',

  data () {
    return {
      value: ''
    }
  },

  computed: {
    ...mapGetters([
      'fieldUserName'
    ])
  },

  methods: {
    ...mapMutations([
      'changeField'
    ]),

    changeFieldValue () {
      this.changeField({
        name: 'fieldUserName',
        value: this.value
      })
    }
  },

  created() {
    this.value = this.fieldUserName
  }
}
</script>
